module.exports = __webpack_public_path__ + "img/zpy.ca4857b4.png";